import { basicEnum } from "./base";

export const DisbursementMethodEnum = basicEnum([
    {
        label: "Tunai",
        value: "cash",
    },
    {
        label: "Xendit",
        value: "xendit",
    },
]);

export namespace DisbursementMethodEnum {
    export type Labels = (typeof DisbursementMethodEnum)["labels"][number];
    export type Values = (typeof DisbursementMethodEnum)["values"][number];
}
